// Application dependencies

import { AddressCrud } from "@/interfaces/address.interfaces";
import { CountriesTable } from "@/interfaces/authorisation/countries.interfaces";
import { StatesTable } from "@/interfaces/authorisation/states.interfaces";
import { TimeZonesTable } from "@/interfaces/authorisation/timeZones.Interfaces";

// Branch Enums ----------------------------------------------------------------------------------------------------------------------------

export enum BranchFields {
  Address = "address",
  CompanyId = "company_id",
  ContactTimeMessage = "contact_time_message",
  Country = "country",
  CountryId = "country_id",
  CreatedAt = "created_at",
  Email = "email",
  Id = "id",
  Key = "key",
  Location = "location",
  Name = "name",
  NormalAddress = "normal_address",
  NormalAddressId = "normal_address_id",
  PostalAddress = "postal_address",
  PostalAddressId = "postal_address_id",
  State = "state",
  StateId = "state_id",
  Telephone = "telephone",
  TimeZone = "time_zone",
  TimeZoneId = "time_zone_id",
  UpdatedAt = "updated_at",
  Zone = "zone",
}

// Branch Interfaces -----------------------------------------------------------------------------------------------------------------------

export interface Branch {
  [BranchFields.Address]: string;
  [BranchFields.CompanyId]: number;
  [BranchFields.ContactTimeMessage]: string;
  [BranchFields.CountryId]: number;
  [BranchFields.CreatedAt]: string | null;
  [BranchFields.Email]: string;
  [BranchFields.Id]: number;
  [BranchFields.Key]: string;
  [BranchFields.Location]: string;
  [BranchFields.Name]: string;
  [BranchFields.NormalAddressId]: number | null;
  [BranchFields.NormalAddress]: AddressCrud | null;
  [BranchFields.PostalAddressId]: number | null;
  [BranchFields.PostalAddress]: AddressCrud | null;
  [BranchFields.StateId]: number;
  [BranchFields.Telephone]: string;
  [BranchFields.TimeZoneId]: number;
  [BranchFields.UpdatedAt]: string | null;
}

export interface BranchCrud {
  [BranchFields.Address]: string;
  [BranchFields.CompanyId]: number;
  [BranchFields.ContactTimeMessage]: string;
  [BranchFields.CountryId]: number;
  [BranchFields.Email]: string;
  [BranchFields.Id]: number | null;
  [BranchFields.Key]: string;
  [BranchFields.Location]: string;
  [BranchFields.Name]: string;
  [BranchFields.NormalAddressId]: number | null;
  [BranchFields.NormalAddress]: AddressCrud | null;
  [BranchFields.PostalAddressId]: number | null;
  [BranchFields.PostalAddress]: AddressCrud | null;
  [BranchFields.StateId]: number;
  [BranchFields.Telephone]: string;
  [BranchFields.TimeZoneId]: number;
}

export interface BranchDetail {
  [BranchFields.Address]: string;
  [BranchFields.CompanyId]: number;
  [BranchFields.ContactTimeMessage]: string;
  [BranchFields.Country]: CountriesTable | null;
  [BranchFields.CreatedAt]: string | null;
  [BranchFields.Email]: string;
  [BranchFields.Id]: number;
  [BranchFields.Key]: string;
  [BranchFields.Location]: string;
  [BranchFields.Name]: string;
  [BranchFields.NormalAddressId]: number | null;
  [BranchFields.NormalAddress]: AddressCrud | null;
  [BranchFields.PostalAddressId]: number | null;
  [BranchFields.PostalAddress]: AddressCrud | null;
  [BranchFields.State]: StatesTable | null;
  [BranchFields.Telephone]: string;
  [BranchFields.TimeZone]: TimeZonesTable | null;
  [BranchFields.UpdatedAt]: string | null;
}
